<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title"> Lịch sử xuất dữ liệu báo cáo</div>
      </div>
      <div class="card card-w-title"  v-if="$myConstants.checkRoleGroup('history_export', 'list')">
        <!-- <div class="list-data" v-if="$myConstants.checkRoleGroup('history_export', 'list')"> -->
          <BaseCommon v-if="dataModel"
            :classDatatable="'list_history_export'"
            :key="componentKey"
            :listData="listData"
            :model="dataModel"
            :filterDefault="filters"
            :dateTypeDateFilterDefault="dateTypeDateFilterDefault"
            v-on:action-click="onActionClicked"
            :actions="getRowActions()"
            @callback="callbackListData"
          ></BaseCommon>
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import BaseCommon from '../common'

export default {
  components: {
    BaseCommon
  },
  data() {
    return {
      filters: {},
      listData: [],
      dataModel: null,
      componentKey: 0,
      disable_update:true,
      listDataExport:[],
      showConfirmDialog:false,
      creenConfirmDialog:'export_success',
      check_success_img: window.origin + '/assets/images/check_success.png',
      err_massage_img: window.origin + '/assets/images/err_massage.png',
      dateTypeDateFilterDefault:null,
      userID : null
    }
  },
  mounted () {
    this.initData();
    if(this.$store.getters.fullname !== undefined && this.$store.getters.fullname !== null){
      if(this.$store.getters.fullname.id !== undefined && this.$store.getters.fullname.id !== null && this.$store.getters.fullname.id !== ''){
        this.userID = this.$store.getters.fullname.id
      }
    }
    
  },
  created () {
    if(this.$route.params.reload) {
      window.location.reload();
    }
  },
  watch: {
    '$route': 'initData'
  },
  methods: {
    initData() {
      setTimeout(async () => {
       // if (this.$myConstants.checkRoleGroup('maintenance', 'list')) {
          await this.initParams();
        //}
      }, 1000);
    },
    checkVisible(groupName, action) {
      return this.$myConstants.checkVisible(this.$store.getters.permission, groupName, action);
    },
    async initParams() {

      this.filters = {};
      this.dateTypeDateFilterDefault = 2;
      this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      //this.filters.address_info = "aa";
      this.modelName = 'history_export';
      var where = {}
      if(this.userID !== null){
        where.user_id ={'_eq' : this.userID}
      }
      var variables = {
        where_key: where,
        orderBy: [
          {id: 'desc'},
        ]
      }
      
      var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      this.dataModel = DataServices.getModel(this.modelName);
      this.dataModel.processData(list);

      this.listData = list;
      this.componentKey++;
      this.$store.commit('setLoading', false);
    },
    callbackListData(col, payload) {
      //var vm = this;
      //console.log("5555555555");
      if (col.name == 'is_assignment') {
        this.disable_update = false;
        if (payload);
      }
    },
    getRowActions() {
      var actions = {}
      var that = this;
      actions.filter = { name: 'clear', icon: 'times-circle'};
      actions.rows = function (rowData) {
        // console.log("rowData",rowData)
        var buttons = {}
        if(rowData.process_status == 1){
          var modelaction;
          buttons.edit = { name: 'download',icon:'download',key_show : 'fa', text: 'Tải về', isText: true,  key: 'id', path: rowData.key_file}
          if (that.dataModel.actions) {
              modelaction = that.dataModel.actions(rowData)
            Object.assign(buttons, modelaction);
          }
        }
          
        return buttons
      }
      return actions
    },
    async onActionClicked(payload) {
      var action = payload.action
      switch (action.name) {
        case 'download':
          var fullPath = action.path;
          var file_excel = 'downloal.xlsx'
          if (fullPath) {
            var startIndex = (fullPath.indexOf('\\') >= 0 ? fullPath.lastIndexOf('\\') : fullPath.lastIndexOf('/'));
            var filename = fullPath.substring(startIndex);
            if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
              file_excel = filename.substring(1);
            }
          }
          var dataResponseDownload = await this.$coreService.callApiDownloadPost('/export_excel/read_file_export',{key_s3:action.path},{})
          var url = URL.createObjectURL(new Blob([dataResponseDownload.data], {
            type: 'application/vnd.ms-excel'
          }))
          var link = document.createElement('a')
          link.href = url;
          link.setAttribute('download', file_excel)
          document.body.appendChild(link)
          link.click()
          break;
      }
    },
  }
   
}
</script>
<style lang="scss">
.box-filters{ margin: 15px 0;
  .p-formgroup-inline { display: flex;flex-wrap: wrap; align-items: flex-start;
    .p-field{ margin-right: 50px; margin-bottom: 15px;
      &:last-child{margin: 0; position: relative;}
      label{display: block;}
      .p-dropdown, input{width: 230px;}
      .btn-cancel{width: 90px;position: absolute; top: 30px;}
    }
  }
}
.external-link{ color: #0066FF; cursor: pointer;
  &.black-color {
    span{color: #000;}
  }
  span{color: #199ED8;}
}
</style>
<style>
.p-checkbox .p-hidden-accessible{
  position: unset!important;
}
</style>